import NewPromoForm from './NewPromoForm';

export default NewPromoForm;